const ENTITY_MAP = {
  '/cohorts': '/cohort',
  '/timed-messages': '/timed-message',
  '/pages': '/page'
};
export const mapEntityToSingular = (entity: string): string => {
  return ENTITY_MAP[entity] ?? entity;
};
